import clone from 'clone';

import {
    CLEAR_AD,
    FETCH_ADS, FETCH_ADS_SUCCESS, FETCH_ADS_FAILURE,
    SAVE_AD, SAVE_AD_SUCCESS, SAVE_AD_FAILURE,
    EMPTY_ADS, SET_AD, SET_ADS
} from './constants';

const initialState = {
    all: [],
    ad: {},
    isFetching: false,
    isSaving: false,
    error: {},
    saveError: {}
};

function adsReducer(state = initialState, action) {
    switch(action.type) {
        case CLEAR_AD:
            return Object.assign({}, state, {
                ad: {}
            });
        case EMPTY_ADS:
            return initialState;
        case FETCH_ADS:
            return Object.assign({}, state, {
                isFetching: true,
                error: {}
            });
        case FETCH_ADS_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                all: action.data
            });
        case FETCH_ADS_FAILURE:
            return Object.assign({}, state, {
                isFetching: false,
                error: action.error
            });
        case SAVE_AD:
            return Object.assign({}, state, {
                isSaving: true,
                saveError: {}
            });
        case SAVE_AD_SUCCESS:
            let newAll = clone(state.all);
            for(var i = 0; i < newAll.length; i++) {
                if(newAll[i].id === action.data.id) {
                    newAll[i] = action.data;
                    break;
                }
            }
            return Object.assign({}, state, {
                isSaving: false,
                ad: action.data,
                all: newAll
            });
        case SAVE_AD_FAILURE:
            return Object.assign({}, state, {
                isSaving: false,
                saveError: action.error
            });
        case SET_AD:
            return Object.assign({}, state, {
                ad: action.data
            });
        case SET_ADS:
            return Object.assign({}, state, {
                all: action.data
            });
        default:
            return state;
    }
}

export default adsReducer;



// WEBPACK FOOTER //
// ./src/containers/AdsPage/store/reducers.js